export default __webpack_public_path__ + "static/media/Mystic's Gauntlets of the Crumbling Tower.5e41b5da.jpg";